// import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import { lock, clearBodyLocks } from 'tua-body-scroll-lock';
import anime from 'animejs';

import { createFocusTrap } from 'focus-trap';

export default {
    init() {
        //////////// Navigation
        const menu = document.getElementById('menu');
        const hamburger = document.getElementById('hamburger');
        const header = document.querySelector('.header-menu') as HTMLElement;
        const body = document.querySelector('body');
        // const closeOverlay = document.querySelector('.header-overlay') as HTMLElement;

        if (!menu || !hamburger || !header || !body) {
            return;
        }

        if (hamburger) {
            hamburger.addEventListener('click', function () {
                const timeline = anime.timeline({
                    duration: 400,
                    easing: 'easeOutQuint'
                });

                // close menu
                if (menu.classList.contains('open')) {
                    menu.classList.remove('open');
                    hamburger.classList.remove('close');
                    header.classList.remove('open-menu');

                    timeline.add({
                        targets: '#menu',
                        opacity: 0,
                        complete: () => {
                            // clearAllBodyScrollLocks();
                            clearBodyLocks();
                        }
                    });
                } else {
                    // open menu
                    // disableBodyScroll(header);
                    lock(header);
                    menu.classList.add('open');
                    hamburger.classList.add('close');
                    header.classList.add('open-menu');

                    timeline.add({
                        targets: '#menu',
                        opacity: 1,
                        // eslint-disable-next-line @typescript-eslint/no-empty-function
                        complete: () => {}
                    });
                }
            });
        }

        const mainButtons = document.querySelectorAll('.main-button') as NodeListOf<HTMLElement>;
        if (!mainButtons) {
            return;
        }

        mainButtons.forEach(function (button: HTMLElement) {
            const subbuttonDiv = button.querySelector('button')?.nextElementSibling as HTMLElement | null;

            const timeline = anime.timeline({
                duration: 400,
                easing: 'easeOutQuint',
                pause: true
            });

            timeline.add({
                targets: subbuttonDiv,
                display: 'flex'
            });

            if (!subbuttonDiv) return;

            let isClosedByFocusTrap = false;

            const focusTrap = createFocusTrap(subbuttonDiv, {
                escapeDeactivates: true,
                clickOutsideDeactivates: true,
                onDeactivate: () => {
                    subbuttonDiv.classList.remove('subbuttons-visible');
                    subbuttonDiv.classList.add('not-visible');

                    setTimeout(() => {
                        subbuttonDiv.classList.add('md:hidden');
                        subbuttonDiv.classList.remove('md:flex');
                    }, 400);

                    isClosedByFocusTrap = true;
                }
            });

            button.addEventListener('click', function () {
                // desktop menu
                if (subbuttonDiv.classList.contains('not-visible') && !isClosedByFocusTrap) {
                    subbuttonDiv.classList.remove('md:hidden');
                    subbuttonDiv.classList.add('md:flex');
                    try {
                        focusTrap.activate();
                    } catch (error) {
                        console.log('Error activating focus trap:', error);
                    }

                    setTimeout(() => {
                        subbuttonDiv.classList.remove('not-visible');
                        subbuttonDiv.classList.add('subbuttons-visible');
                    }, 100);
                } else if (!subbuttonDiv.classList.contains('not-visible') && !isClosedByFocusTrap) {
                    subbuttonDiv.classList.remove('subbuttons-visible');
                    subbuttonDiv.classList.add('not-visible');

                    setTimeout(() => {
                        subbuttonDiv.classList.add('md:hidden');
                        subbuttonDiv.classList.remove('md:flex');
                        try {
                            focusTrap.deactivate();
                        } catch (error) {
                            console.log('Error deactivating focus trap:', error);
                        }
                    }, 400);
                }

                isClosedByFocusTrap = false;

                // mobile menu handling
                if (isButtonOpen(button)) {
                    closeSubmenu(button);
                } else {
                    mainButtons.forEach((mainButton) => {
                        closeSubmenu(mainButton);
                    });

                    openSubmenu(button);
                }
            });

            // mobile accordion
            function closeSubmenu(mainButton: HTMLElement) {
                const subbuttonMobile = mainButton.querySelector('.subbuttons-mobile') as HTMLElement | null;
                const menuLink = mainButton.querySelector('.mobile-icon-div') as HTMLElement;
                if (!subbuttonMobile || !menuLink) return;

                subbuttonMobile.setAttribute('style', 'maxHeight:0;');
                subbuttonMobile.classList.remove('subbuttons-mobile-visible');
                subbuttonMobile.classList.add('subbuttons-mobile-hidden');
                menuLink.classList.remove('rotated');
            }

            function openSubmenu(mainButton: HTMLElement) {
                const subbuttonMobile = mainButton.querySelector('.subbuttons-mobile') as HTMLElement | null;
                const menuLink = mainButton.querySelector('.mobile-icon-div') as HTMLElement;
                if (!subbuttonMobile || !menuLink) return;
                subbuttonMobile.classList.remove('subbuttons-mobile-hidden');
                subbuttonMobile.classList.add('subbuttons-mobile-visible');
                subbuttonMobile.style.maxHeight = subbuttonMobile.scrollHeight + 20 + 'px';
                menuLink.classList.add('rotated');
            }

            function isButtonOpen(mainButton: HTMLElement) {
                const subbuttonMobile = mainButton.querySelector('.subbuttons-mobile') as HTMLElement | null;
                if (!subbuttonMobile) return false;
                return subbuttonMobile.classList.contains('subbuttons-mobile-visible');
            }
        });
    }
};
